var map = {
	"./about-app/game.svg": 659,
	"./about-app/learn.svg": 660,
	"./about-app/scan.svg": 661,
	"./about-app/tips.svg": 662,
	"./arrow.svg": 556,
	"./bt-round-active.svg": 567,
	"./bt-round-hover.svg": 568,
	"./bt-round.svg": 569,
	"./check-box-checked.svg": 555,
	"./close.svg": 663,
	"./contract.svg": 664,
	"./done.svg": 570,
	"./download.svg": 665,
	"./east-arrow.svg": 557,
	"./email.svg": 666,
	"./feedback.svg": 301,
	"./game.svg": 667,
	"./go.svg": 668,
	"./link.svg": 571,
	"./menu.svg": 669,
	"./next.svg": 670,
	"./polygon_arrow.svg": 562,
	"./search.svg": 671,
	"./sign.svg": 302,
	"./vertical_dots.svg": 554,
	"./words-containing-outlined.svg": 672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 658;